export default __webpack_public_path__ + "static/media/MelbourneLevel1West_bkup.0fb38c16.jpg";